import type React from "react";
import styles from "./icon.module.css";

export type IconProps = {
  title?: string;
  titleId?: string;
  size?: number;
  color?: string;
  colorHover?: string;
  viewBox?: string;
  paths?: string[];
} & React.AllHTMLAttributes<HTMLOrSVGElement>;

export function Icon({
  size = 32,
  viewBox = "0 0 32 32",
  title,
  paths,
  color = "#2e2d37",
  titleId,
  ...props
}: IconProps) {
  return (
    <svg
      className={styles.Svg}
      width={size}
      height={size}
      viewBox={viewBox}
      {...props}
    >
      {title && <title id={titleId ?? ""}>{title}</title>}
      {paths?.map((path, index) => {
        return (
          <path className={styles.Path} d={path} fill={color} key={index} />
        );
      })}
    </svg>
  );
}
